<template>
	<CRow>
		<CCol>
			<CCard>
				<CCardHeader>
					<CRow>
						<CCol><h5 class="my-2">File Import Status</h5> </CCol>
					</CRow>
				</CCardHeader>
				<CCardBody :style="{ position: 'relative', top: '-18px' }">
					<CDataTable
						:items="uploadStatus"
						:fields="fields"
						:column-filter="false"
						:itemsPerPageSelect="true"
						hover
						sorter
						pagination
						@filtered-items-change="setCurrentItems"
					>
						<template #status="{ item }">
							<td
								class="font-weight-bold"
								:style="`color: ${getColorOnStatus(getAccountStatus(item))}`"
							>
								{{ getAccountStatus(item) }}
							</td>
						</template>
						<template #created_on="{ item }">
							<td>{{ getTimeFromTable(item) }}</td>
						</template>
						<template #client_name="{ item }">
							<td>{{ getClientName(item) }}</td>
						</template>
					</CDataTable>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import { storeData } from "../../store";
import gql from "graphql-tag";
import _ from "../../utility/utility";

const fields = [
	{ key: "type" },
	{ key: "fileName" },
	{ key: "client_name", label: "Client / Hospital Name" },
	{ key: "created_on", label: "Uploaded On" },
	{ key: "status", label: "Status" },
];

const GET_FILE_UPLOADS = gql`
	query fileUploads {
		spendmd_db_file_upload_status(order_by: { created_on: desc_nulls_last }) {
			id
			type
			fileName
			completed
			failed
			created_on
			client {
				name
			}
		}
	}
`;

export default {
	props: {
		client_id: String,
	},
	data() {
		return {
			currentItems: [],
			uploadStatus: [],
			fields,
			eachUserModal: false,
			userApprovalComment: "",
		};
	},
	methods: {
		getClientName(item) {
			return item?.client?.name;
		},
		getTimeFromTable(item) {
			return _.getTimeFromTable(item.created_on);
		},
		getAccountStatus(item) {
			if (item.completed && !item.failed) {
				return "Completed";
			} else if (item.failed) {
				return "Data Invalid";
			} else {
				return "Pending";
			}
		},
		getColorOnStatus(status) {
			if (status === "Completed") {
				return "#0bbd40";
			} else if (status === "Data Invalid") {
				return "#ff6700";
			} else {
				return "#b6bccb";
			}
		},

		setCurrentItems(val) {
			this.currentItems = val;
		},
	},
	beforeMount() {
		this.$apollo.queries.userData.refetch();
	},
	apollo: {
		userData: {
			query: GET_FILE_UPLOADS,
			update: (data) => data,
			result({ data }) {
				this.uploadStatus = data.spendmd_db_file_upload_status;
			},
		},
	},
};
</script>

<style scoped>
textarea.form-control {
	height: 112px !important;
}
</style>
